if (!customElements.get('back-in-stock-form')) {
  customElements.define(
    'back-in-stock-form',
    class BackInStockForm extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.variantSelect?.addEventListener('change', () => this.updateRequestFromSelectedVariant(), { signal });
        this.consentInput?.addEventListener('invalid', () => this.showConsentError(), { signal });
        this.consentInput?.addEventListener(
          'change',
          () => {
            if (this.consentInput.checked) this.clearConsentError();
          },
          { signal }
        );

        this.updateRequestFromSelectedVariant();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      updateVariant(variant) {
        if (!this.variantSelect?.options.length) {
          this.hidden = true;
          return;
        }

        if (variant && variant.available === false) {
          const matchingOption = Array.from(this.variantSelect.options).find(
            (option) => option.value === String(variant.id)
          );
          if (matchingOption) this.variantSelect.value = matchingOption.value;
        }

        this.hidden = false;
        this.updateRequestFromSelectedVariant();
      }

      updateRequestFromSelectedVariant() {
        const selectedOption = this.variantSelect?.selectedOptions?.[0];
        if (!selectedOption) return;

        const variantTitle = selectedOption.dataset.variantTitle || selectedOption.textContent.trim();
        const variantValue = `${variantTitle} (#${selectedOption.value})`;
        const variantInput = this.querySelector('[data-back-in-stock-variant-input]');
        if (variantInput) variantInput.value = variantValue;

        const bodyInput = this.querySelector('[data-back-in-stock-body]');
        if (bodyInput) {
          bodyInput.value = `${this.dataset.requestLabel}: ${this.dataset.productTitle} — ${variantValue}`;
        }

        const variantLabel = this.querySelector('[data-back-in-stock-variant]');
        if (variantLabel) variantLabel.textContent = variantTitle;
      }

      showConsentError() {
        if (!this.consentInput) return;
        this.consentInput.setAttribute('aria-invalid', 'true');
        if (this.consentError) this.consentError.hidden = false;
      }

      clearConsentError() {
        this.consentInput?.removeAttribute('aria-invalid');
        if (this.consentError) this.consentError.hidden = true;
      }

      get consentInput() {
        return this.querySelector('[data-back-in-stock-consent]');
      }

      get variantSelect() {
        return this.querySelector('[data-back-in-stock-variant-select]');
      }

      get consentError() {
        return this.querySelector('[data-back-in-stock-consent-error]');
      }
    }
  );
}
